import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { tokenAtom, paramAtom } from '../../core/config/atoms';

import { toast } from 'react-toastify';
import grapesjs from 'grapesjs';
import grapesPlugBlocksBasic from 'grapesjs-blocks-basic';
import 'grapesjs/dist/css/grapes.min.css';

import ServiceResearch from 'services/serviceResearch';
import ServiceMedia from 'services/serviceMedia';
import ServiceStdPage from 'services/serviceStdPage';
import ServicePortal from 'services/servicePortal';
import ServiceAddPage from 'services/serviceAddPage';

export default function PanelStyle(props) {
    const editorRef = useRef(null);

    const [token] = useRecoilState(tokenAtom);
    const [param, setParam] = useRecoilState(paramAtom);

    const navigate = useNavigate();
    const researchService = new ServiceResearch();
    const stdPageService = new ServiceStdPage();
    const addPageService = new ServiceAddPage();
    const portalService = new ServicePortal();
    const mediaService = new ServiceMedia();

    const goBack = () => {
        let key = param.key;
        setParam({});
        props.toggle();
        switch (key) {
            case 'research':
                navigate(`/home/research`);
                break;
            case 'std':
                navigate(`/home/spage`);
                break;
            case 'portal':
                navigate(`/home/portal`);
                break;
            case 'addPage':
                navigate(`/home/apage`);
                break;
            default:
                navigate(`/home/main`);
        }
    }

    const handleSave = () => {
        const components = editorRef.current.getComponents();
        const allCSS = editorRef.current.getCss();
        const allHTML = editorRef.current.getHtml();
        const payLoad = {
            html: allHTML,
            components: components.toJSON(),
            styles: allCSS,
        };
        var body = {
            'uid': param.id,
            'data': payLoad
        };
        let key = param.key;
        switch (key) {
            case 'research':
                researchService.updateResearchPage(body, token).then((res) => {
                    if (res) {
                        toast.success('Research page style updated.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    } else {
                        toast.error(res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
                break;
            case 'std':
                stdPageService.updateStdPagePage(body, token).then((res) => {
                    if (res) {
                        toast.success('Standard page style updated.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    } else {
                        toast.error(res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
                break;
            case 'portal':
                portalService.updatePortalPage(body, token).then((res) => {
                    if (res) {
                        toast.success('Portal page style updated.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    } else {
                        toast.error(res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
                break;
            case 'addPage':
                addPageService.updateAddPagePage(body, token).then((res) => {
                    if (res) {
                        toast.success('Addtional page style updated.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    } else {
                        toast.error(res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
                break;
            default:
                break;
        }
    };

    const loadMedia = () => {
        (async function () {
            let iliknks = ["https://storage.googleapis.com/sche-web/assets/placeholder.jpg"];
            var mdoc = await mediaService.getAllMedia({}, token);
            mdoc.data.map((item) => {
                item.files.map((fileItem) => {
                    iliknks.push(fileItem.fileurl);
                })
            })
            editorRef.current = grapesjs.init({
                container: '#gjs',
                height: '100vh',
                width: 'auto',
                fromElement: false,
                storageManager: false,
                plugins: [grapesPlugBlocksBasic],
                pluginsOpts: {
                    [grapesPlugBlocksBasic]: {}
                },
                assetManager: {
                    assets: iliknks,
                    upload: false,
                },
            });

            editorRef.current.StyleManager.addSector('Custome', {
                name: 'Custome',
                open: true,
                buildProps: ['color'],
                properties: [
                    {
                        property: 'color',
                        type: 'select',
                        label: 'Text Color',
                        defaults: '#000',
                        options: [
                            { value: '#61412A', name: 'Prime Brand 100' },
                            { value: '#B09172', name: 'Prime Brand 200' },
                            { value: '#D8C8B9', name: 'Prime Brand 300' },
                            { value: '#722024', name: 'Red Brand 100' },
                            { value: '#9B2B2D', name: 'Red Brand 200' },
                            { value: '#C4373E', name: 'Red Brand 300' },
                            { value: '#203F20', name: 'Green Brand 100' },
                            { value: '#3E583A', name: 'Green Brand 200' },
                            { value: '#5C7F55', name: 'Green Brand 300' },
                            { value: '#322F59', name: 'Prep Brand 100' },
                            { value: '#453F78', name: 'Prep Brand 200' },
                            { value: '#FFC94A', name: 'Yellow Brand 50' },
                            { value: '#FFC300', name: 'Yellow Brand 100' },
                            { value: '#957C63', name: 'Secundy Brand 100' },
                            { value: '#FFF6EA', name: 'Secundy Brand 200' },
                        ]
                    }
                ]
            });
        })();
    }

    const loadData = () => {
        (async function () {
            var res = {};
            let key = param.key;
            let body = {};
            switch (key) {
                case 'std':
                    body = {
                        "rid": param.id,
                    };
                    res = await stdPageService.getStdPageById(body, token);
                    break;
                case 'research':
                    body = {
                        "rid": param.id,
                    };
                    res = await researchService.getResearchById(body, token);
                    break;
                case 'portal':
                    body = {
                        "rid": param.id,
                    };
                    res = await portalService.getPortalById(body, token);
                    break;
                case 'addPage':
                    body = {
                        "rid": param.id,
                    };
                    res = await addPageService.getAddPageById(body, token);
                    break;
            }

            if (res['status']) {
                const editor = editorRef.current;
                const components = editor.getComponents();
                const styles = editor.getStyle();

                components.reset();
                styles.reset();

                if (res.data.pageData !== null) {
                    components.add(res.data.pageData.components);
                    editor.setStyle(res.data.pageData.styles);
                }
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    useEffect(() => {
        loadMedia();
        loadData();

        return () => {
            if (editorRef.current) {
                editorRef.current.destroy();
            }
        };
    }, []);

    return (
        <div className="w-full h-full p-2 flex flex-col overflow-auto">
            <div className="p-3">
                <div className="intro-y flex items-center cursor-pointer" onClick={() => { goBack() }}>
                    <i className="las la-long-arrow-alt-left text-xl"></i>
                    <h4 className="text-xs text-black font-sans font-medium ml-2">Back to all pages</h4>
                </div>
                <div className="intro-y mt-2">
                    <div className='flex items-center justify-between'>
                        <h3 className="text-2xl font-sans font-bold text-gray-800 my-2">Page Customization</h3>
                        <button className="h-10 py-1 px-3 rounded-md bg-prime hover:bg-primeLight text-white mr-4 text-sm" onClick={() => { handleSave(); }}>SAVE PAGE</button>
                    </div>
                    <hr />
                </div>
            </div >
            <div className='w-full h-screen rounded' id="gjs">

            </div>
        </div>
    )
}
